import React from 'react';

import { Container, Cards } from './styles';

import Card3D from '../../components/Card3D';

import goBarber from '../../assets/screenshot-gobarber.jpg';
import githubExplorer from '../../assets/screenshot-github-explorer.jpg';
import discordClone from '../../assets/screenshot-discord.jpg';
import twitterClone from '../../assets/screenshot-twitter.jpg';
import githubClone from '../../assets/screenshot-github.jpg';
import dropboxClone from '../../assets/screenshot-dropbox.jpg';
import linkedinClone from '../../assets/screenshot-linkedin.jpg';
import pinterestClone from '../../assets/screenshot-pinterest.jpg';

export default function Projects() {
  return (
    <>
      <Container id='projects'>
        <h1>Projects</h1>

        <Cards>
          <Card3D
            urlImg={goBarber}
            name='GoBarber'
            description='Scheduling application for beauty services, between service providers and clients'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/gobarber'
            a
          />

          <Card3D
            urlImg={githubExplorer}
            name='GitHub Explorer'
            description="Explore diverse repositories from this application that consumes the API of the world's largest source code hosting platform"
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/github-explorer'
          />

          <Card3D
            urlImg={discordClone}
            name='Discord Clone'
            description='Discord user interface clone'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/discord-clone'
          />

          <Card3D
            urlImg={twitterClone}
            name='Twitter Clone'
            description='Twitter user interface clone'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/twitter-clone'
          />

          <Card3D
            urlImg={githubClone}
            name='GitHub Clone'
            description='GitHub user interface clone'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/github-clone'
          />

          <Card3D
            urlImg={dropboxClone}
            name='Dropbox Clone'
            description='Dropbox user interface clone'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/dropbox-clone'
          />

          <Card3D
            urlImg={linkedinClone}
            name='LinkedIn Clone'
            description='LinkedIn user interface clone'
            techs='React and Styled Components'
            urlRepository='https://github.com/CaioMantovaniBorba/linkedin-clone'
          />

          <Card3D
            urlImg={pinterestClone}
            name='Pinterest Clone'
            description='Pinterest user interface clone'
            techs='HTML, CSS and JavaScript'
            urlRepository='https://github.com/CaioMantovaniBorba/pinterest-clone'
          />
        </Cards>

        <a
          href='https://github.com/CaioMantovaniBorba?tab=repositories'
          target='_blank'
          rel='noopener noreferrer'
          className='more'
        >
          MORE PROJECTS
        </a>
      </Container>
    </>
  );
}
